import { VizConfig } from "@/shared/config/VizConfig";
import {
  LayoutDefinition,
  LayoutDefinitionBuilder,
} from "@/shared/domain/layouts";
import { LoggerService } from "@/shared/services";
import { State } from "@/shared/state/visualization";

/**
 * Converts a {@link State} object into a {@link LayoutDefinition}.
 */
export function vizConfigToLayout(vizState: State): LayoutDefinition {
  LoggerService.log("Creating layout from viz state:", vizState);

  const vizConfig = new VizConfig(vizState);

  if (vizConfig.hasPanels() === false) {
    return new LayoutDefinition();
  }

  const layoutDefinitionBuilder = new LayoutDefinitionBuilder();

  for (const panel of vizConfig.iterPanels()) {
    const { data: _, ...panelMetadata } = panel;
    const panelDataAndStyles = VizConfig.getDataAndStylesForPanel(panel);

    const ruleIds = panelDataAndStyles.map(({ data, style }) => {
      const requirementSet = data.map((topicData) =>
        LayoutDefinitionBuilder.createRequirementFromTopicData(topicData),
      );
      return layoutDefinitionBuilder.addRule(requirementSet, style);
    });

    layoutDefinitionBuilder.addPanel(panelMetadata, ruleIds);
  }

  layoutDefinitionBuilder.setLayout(vizConfig.layout);

  return layoutDefinitionBuilder.build();
}
